module.exports = __webpack_public_path__ + "static/media/logo.337e1a0b.svg";